import { render, staticRenderFns } from "./StudentNominate.vue?vue&type=template&id=56b00e40"
import script from "./StudentNominate.vue?vue&type=script&lang=js"
export * from "./StudentNominate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports